export const RECORDED_SHORTAGES_ENABLED = false;